import { render, staticRenderFns } from "./guokeAgentMaterial.vue?vue&type=template&id=ef32a78e&scoped=true"
import script from "./guokeAgentMaterial.vue?vue&type=script&lang=js"
export * from "./guokeAgentMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef32a78e",
  null
  
)

export default component.exports